import React, { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PuffLoader } from "react-spinners";

import {
  getAllCars,
  selectCars,
  selectLoadingState,
  selectErrorState,
} from "../../redux/car/car-slice";
import {
  getLastOperdon,
  selectOperdons,
  selectLoadingOperdonState,
  selectErrorOperdonState,
} from "../../redux/operdon/operdon-slice";

import {
  selectDelSuccessState as selectDelCarSuccess,
  resetDeleteState as resetCarDelete,
} from "../../redux/car/car-del-slice";
import {
  selectDelSuccessOperdonState as selectDelOperdonSuccess,
  resetDeleteState as resetOperdonDelete,
} from "../../redux/operdon/operdon-del-slice";

import OrginalPage from "./orginal-page";
import Empty from "../empty-message/empty";
import ErrorBox from "../pages/errorBox";
import SpinnerWrapper from "../pages/spinnerWrapper";

const Home = () => {
  const dispatch = useDispatch();

  // ---- Cars ----
  const cars = useSelector(selectCars);
  const carIsLoading = useSelector(selectLoadingState);
  const carHasError = useSelector(selectErrorState);
  const carDeleteSuccess = useSelector(selectDelCarSuccess);

  // ---- Operdons ----
  const operdons = useSelector(selectOperdons);
  const operdonIsLoading = useSelector(selectLoadingOperdonState);
  const operdonHasError = useSelector(selectErrorOperdonState);
  const operdonDeleteSuccess = useSelector(selectDelOperdonSuccess);

  // --- بار اول دیتا لود می‌شود ---
  useEffect(() => {
    dispatch(getAllCars());
    dispatch(getLastOperdon());
  }, [dispatch]);

  // --- بعد از حذف خودرو ---
  useEffect(() => {
    if (carDeleteSuccess) {
      dispatch(getAllCars());
      dispatch(resetCarDelete());
    }
  }, [carDeleteSuccess, dispatch]);

  // --- بعد از حذف اپردون ---
  useEffect(() => {
    if (operdonDeleteSuccess) {
      dispatch(getLastOperdon());
      dispatch(resetOperdonDelete());
    }
  }, [operdonDeleteSuccess, dispatch]);

  // --- محتوای صفحه ---
  const renderContent = () => {
    if (carIsLoading || operdonIsLoading) {
      return (
        <SpinnerWrapper>
          <PuffLoader color="green" loading={true} size={60} />
        </SpinnerWrapper>
      );
    }
    if (carHasError || operdonHasError) {
      return <ErrorBox />;
    }
    if ((cars?.length ?? 0) === 0) {
      return <Empty />;
    }
    return <OrginalPage />;
  };

  return <Fragment>{renderContent()}</Fragment>;
};

export default Home;
